import { PAGE_KEYS } from "../_core/pageKeys";
import { PAGE_TEMPLATE_TYPES, TEMPLATE_KEYS } from "../_core/templateTypes";

export default {
  key: TEMPLATE_KEYS.DEFAULT,
  defaultLocale: "zh-TW",
  defaultCurrency: "TWD",
  checkout: {
    lineId: {
      enabled: true,
      required: false,
    },
    phone: {
      preset: "tw",
    },
    delivery: {
      enabledModes: ["delivery", "pickup_711"],
    },
    payment: {
      enabledMethods: ["cod"],
      defaultMethod: "cod",
      provider: null,
      currency: "TWD",
    },
    continuePayment: {
      mode: "legacy",
      provider: null,
      cashierPath: "/sub/payment/cashier",
    },
  },
  resources: {
    layoutHeaderUrl: "layout-header",
    layoutFooterUrl: "layout-footer",
    userHeaderUrl: "layout-user-header",
    userFooterUrl: "layout-user-footer",
  },
  pages: {
    [PAGE_KEYS.HOME]: {
      type: PAGE_TEMPLATE_TYPES.LOWCODE,
      layout: "default",
    },
  },
  sections: {},
};
